import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'time',
  standalone: true
})
export class TimePipe implements PipeTransform {
  private readonly translations = {
    en: {
      fewSeconds: 'few seconds ago',
      min: 'min',
      mins: 'mins',
      hour: 'hour',
      hours: 'hours',
      day: 'day',
      days: 'days',
      month: 'month',
      months: 'months',
      year: 'year',
      years: 'years',
      ago: 'ago'
    },
    bn: {
      fewSeconds: 'কয়েক সেকেন্ড আগে',
      min: 'মিনিট',
      mins: 'মিনিট',
      hour: 'ঘণ্টা',
      hours: 'ঘণ্টা',
      day: 'দিন',
      days: 'দিন',
      month: 'মাস',
      months: 'মাস',
      year: 'বছর',
      years: 'বছর',
      ago: 'আগে'
    }
  };

  private readonly bengaliDigits = ['০', '১', '২', '৩', '৪', '৫', '৬', '৭', '৮', '৯'];

  transform(value: string | number | null | undefined, language: 'en' | 'bn' = 'en'): string {
    if (value === null || value === undefined || value === '') {
      return '';
    }

    if (typeof value === 'string') {
      const date = new Date(value);
      const now = new Date();
      const diffInMs = now.getTime() - date.getTime();
      value = Math.floor(diffInMs / 60000); // convert milliseconds to minutes
    }

    const minutesAgo = value;
    
    if (minutesAgo < 0) {
      return ''; // Future times not handled
    }

    // Less than 1 minute
    if (minutesAgo < 1) {
      return this.translations[language].fewSeconds;
    }

    let count: number;
    let unit: string;

    // Less than 60 minutes
    if (minutesAgo < 60) {
      count = Math.floor(minutesAgo);
      unit = count === 1 ? this.translations[language].min : this.translations[language].mins;
    }
    // Less than 1440 minutes (24 hours)
    else if (minutesAgo < 1440) {
      count = Math.floor(minutesAgo / 60);
      unit = count === 1 ? this.translations[language].hour : this.translations[language].hours;
    }
    // Less than 43200 minutes (30 days)
    else if (minutesAgo < 43200) {
      count = Math.floor(minutesAgo / 1440);
      unit = count === 1 ? this.translations[language].day : this.translations[language].days;
    }
    // Less than 518400 minutes (12 months)
    else if (minutesAgo < 518400) {
      count = Math.floor(minutesAgo / 43200);
      unit = count === 1 ? this.translations[language].month : this.translations[language].months;
    }
    // 12 months or more
    else {
      count = Math.floor(minutesAgo / 518400);
      unit = count === 1 ? this.translations[language].year : this.translations[language].years;
    }

    const countStr = language === 'bn' ? this.toBengaliNumber(count) : count.toString();
    return `${countStr} ${unit} ${this.translations[language].ago}`;
  }

  private toBengaliNumber(num: number): string {
    return num.toString().split('').map(digit => this.bengaliDigits[parseInt(digit)]).join('');
  }
}
